import { StorageK } from 'keys';

export const STORAGE_V = 'STORAGE_V';

export const loadPrevState = <T>(
	mainKey: StorageK,
	tenantId: string,
	ssoId: string,
	version?: number
) => {
	try {
		const stored = localStorage.getItem([mainKey, tenantId, ssoId].join('.'));
		if (!stored) {
			return null;
		}

		const state = JSON.parse(stored);
		if (version && state[STORAGE_V] !== version) {
			return null;
		}

		return state.data as T;
	} catch (err) {
		/* istanbul ignore next: no need to test this */
		return null;
	}
};

export const storeState = <T = any>(
	mainKey: StorageK,
	tenantId: string,
	ssoId: string,
	version: number,
	data: T | null
) => {
	const key = [mainKey, tenantId, ssoId].join('.');

	/* istanbul ignore next: no need to test this */
	if (!data) {
		localStorage.removeItem(key);
		return;
	}

	localStorage.setItem(
		key,
		JSON.stringify({
			data,
			[STORAGE_V]: version
		})
	);
};
